import { Resources } from 'constants/resources';

import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { AutocompleteInput } from 'shared/react-admin/Inputs';
import { ReferenceInput } from 'shared/react-admin/ReferenceInputs';

export const CommissionsCalculationMethodInput: React.FC = () => {
  const translate = useTypedTranslate();

  return (
    <ReferenceInput
      perPage={100}
      reference={Resources.CommissionCalculationMethods}
      source="calculationMethod"
    >
      <AutocompleteInput
        filterToQuery={(searchText: string) => ({ description: searchText })}
        fullWidth
        isRequired
        label={translate('app.commissions.calculationMethod')}
        optionText="description"
        source="calculationMethod"
        variant="outlined"
      />
    </ReferenceInput>
  );
};
